import { Dropdown, Flex, Menu, Text } from '@lego/klik-ui';
import { FORCED_ROLES, type ForcedRole, useUserStore } from '@/stores/user_store';

// Admin gets full access by default, so the no-override option is labelled "Admin".
const ADMIN_VALUE = 'admin';

export const RoleToggle = ({ onRoleChanged }: { onRoleChanged?: () => void }) => {
  const forcedRole = useUserStore((s) => s.forcedRole);
  const setForcedRole = useUserStore((s) => s.setForcedRole);
  const isAdmin = useUserStore((s) => s.isAdmin);

  if (!isAdmin) return null;

  return (
    <>
      <Menu.Divider />
      <Flex alignItems="center" gap={2} px={3} py={2}>
        <Text fontWeight="medium">Role</Text>
        <Dropdown
          flex={1}
          onChange={(value: string) => {
            setForcedRole(value === ADMIN_VALUE ? null : (value as ForcedRole));
            onRoleChanged?.();
          }}
          size="sm"
          value={[forcedRole ?? ADMIN_VALUE]}
        >
          {[
            <Dropdown.Option key={ADMIN_VALUE} value={ADMIN_VALUE}>
              Admin
            </Dropdown.Option>,
            ...FORCED_ROLES.map((role) => (
              <Dropdown.Option key={role} value={role}>
                {role}
              </Dropdown.Option>
            )),
          ]}
        </Dropdown>
      </Flex>
    </>
  );
};
